class ExemptionService {
    async requestExemption(registration, qrCode, recaptchaResponse, exemptionDuration) {

        let url = `${process.env.REACT_APP_API_ENDPOINT}/site/${qrCode}/exemption/${registration}?response=${recaptchaResponse}`;

        if (exemptionDuration) {
            url += `&exemptionDuration=${exemptionDuration}`;
        }

        const rawResponse = await fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
            }
        });
        return await rawResponse.json();
    }
}

export default ExemptionService;